// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IChatsCustomActionRequest,
  TChatsCustomActionModel,
  IMappers,
  TChatsCustomActionResponse,
  IChatsCustomActionResponseError,
} from './types';

export const defaultConfig: TChatsCustomActionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/custom-action/',
  requestType: 'json',
} as TChatsCustomActionModel;

export function createChatsCustomActionModel(parameters: IChatsCustomActionRequest): TChatsCustomActionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsCustomActionOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: IChatsCustomActionRequest;
}

export async function fetchChatsCustomAction<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsCustomActionOptions<TResponse400>): Promise<TChatsCustomActionResponse | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createChatsCustomActionModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IChatsCustomActionResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TChatsCustomActionResponse;
}
